<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown v-if="isCanPay" no-flip>
                <template slot="button-content">
                    <i class="cus-page-white-go"></i>
                    Credits ({{ tabCount }})
                </template>
                <div>
                    <b-dropdown-item @click="displayList()">
                        <i class="cus-page-white-go"></i>
                        View Credits
                    </b-dropdown-item>
                </div>

                <li class="dropdown-divider"></li>

                <b-dropdown-item
                    @click.stop="createCredit"
                    :disabled="isHasUsersChooseInvoice"
                >
                    <i class="cus-add"></i>
                    New Credit
                </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav v-else name="tab-credits">
                <b-nav-item @click="displayList()">
                    <i class="cus-page-white-go"></i>
                    Credits ({{ tabCount }})
                </b-nav-item>
            </b-nav>
        </template>
        <b-card-text>
            <credit-list
                ref="creditList"
                :key="keyview"
                :invoice="invoice"
                v-on="$listeners"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import CreditList from "@/components/invoice-credit/credit-list";
import BILLINGS from "@/constants/billings";
import invoiceHelper from "@/mixins/invoice";
import { isEmpty } from "lodash";
export default {
    mixins: [invoiceHelper],
    components: {
        CreditList
    },
    data() {
        return {
            keyview: 0
        };
    },
    props: {
        invoice: {
            type: Object,
            required: true
        },
        tabCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        isCanPay() {
            return (
                !this.invoice.isPaid &&
                this.invoice.isBusinessActorActive &&
                this._hasAccess("billing.credit.create") &&
                this.invoice.status != BILLINGS.INVOICE.TYPE_CLOSED &&
                this.invoice.status != BILLINGS.INVOICE.TYPE_REOPENED &&
                this.invoice.balance > 0
            );
        },
        isHasUsersChooseInvoice() {
            return !isEmpty(
                this.$store.getters["billing/findUserChooseInvoice"](
                    this.invoice.id
                )
            );
        }
    },
    methods: {
        displayList() {
            this.keyview += 1;
            this.$root.$emit("reload-count", 3);
        },
        async createCredit() {
            let proceed = await this.checkInvoiceStatus(this.invoice.id);
            proceed
                ? this.$emit("create-credit")
                : this.$emit("reload-invoice-details");
        }
    }
};
</script>
